import { render, staticRenderFns } from "./ShareFileDialog.vue?vue&type=template&id=1fe6e10c&scoped=true&"
import script from "./ShareFileDialog.vue?vue&type=script&lang=js&"
export * from "./ShareFileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe6e10c",
  null
  
)

export default component.exports